import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from '@fluentui/react-components';
import { TilesGridLoadingCell } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';

export const LoadingSpinner = ({
  onLoading,
}) => (
  <TilesGridLoadingCell containerClass="loading-cell" onLoading={onLoading}>
    <Spinner size="tiny" />
  </TilesGridLoadingCell>
);

LoadingSpinner.propTypes = {
  onLoading: PropTypes.func.isRequired,
};
